import Warning from 'components/Login/Warning'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Form, Message } from 'semantic-ui-react'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'

const loginMethodsMap = {
  email_password: 'Email and password',
  sso: 'SSO',
}

const loginActionMap = {
  sso: 'SSO',
}

const InviteeRegistration = ({
  inviterName,
  company,
  name,
  password,
  onTextChange,
  availableLoginMethods,
  onSubmit,
}) => {
  const availableMethods = availableLoginMethods.filter((method) => method !== 'sso')
  const hasSso = availableLoginMethods.includes('sso')

  const expandMethods = (methods) => {
    const hasOtherMethods = methods.some((method) => method !== 'social_login') || hasSso

    return methods.flatMap((method) => {
      if (method === 'social_login') {
        return hasOtherMethods ? ['Google', 'Microsoft'] : ['Google or Microsoft']
      }
      return [loginMethodsMap[method]]
    })
  }

  const expandActions = (methods) => {
    const hasOtherMethods = methods.some((method) => method !== 'social_login') || hasSso

    return methods.flatMap((method, index) => {
      if (method === 'social_login') {
        return hasOtherMethods
          ? ['click Log in with Google, Microsoft']
          : ['click Log in with Google or Microsoft']
      }
      if (method === 'email_password') {
        const text = index === 0 ? 'use your Email and password' : 'Email and password'
        return [text]
      }
      return [loginActionMap[method]]
    })
  }

  const formatMethodsList = (methods, conjunction = 'or') => {
    if (methods.length === 1) {
      return methods[0]
    }
    if (methods.length === 2) {
      return `${methods[0]} ${conjunction} ${methods[1]}`
    }
    return `${methods.slice(0, -1).join(', ')}, ${conjunction} ${methods[methods.length - 1]}`
  }

  const formatActionsListJSX = (actions, conjunction = 'or') => {
    if (actions.length === 1) {
      return <strong>{actions[0]}</strong>
    }

    if (actions.length === 2) {
      return (
        <>
          <strong>{actions[0]}</strong> {conjunction} <strong>{actions[1]}</strong>
        </>
      )
    }

    return (
      <>
        {actions.slice(0, -1).map((action, index) => (
          <React.Fragment key={index}>
            <strong>{action}</strong>
            {index < actions.length - 2 ? ', ' : ''}
          </React.Fragment>
        ))}
        , {conjunction} <strong>{actions[actions.length - 1]}</strong>
      </>
    )
  }

  // Warning message string prep
  const availableMethodsString = formatMethodsList([
    ...expandMethods(availableMethods),
    ...(hasSso ? [loginMethodsMap.sso] : []),
  ])

  const availableActionsJSX = formatActionsListJSX([
    ...expandActions(availableMethods),
    ...(hasSso ? [loginActionMap.sso] : []),
  ])

  return (
    <Page>
      <AuthenticationShell
        headerText={
          <>
            <i className="icon user" /> Create your new account
          </>
        }
      >
        {inviterName && company ? (
          <p>
            You've been invited by&nbsp;
            <strong>{inviterName}</strong> to join&nbsp;
            <strong>{company}</strong> on Simplesat.&nbsp; Create an account to log in to your new
            dashboard.
          </p>
        ) : (
          <p>
            You've been invited to join Simplesat.&nbsp; Create an account to log in to your new
            dashboard.
          </p>
        )}
        {availableLoginMethods.length ? (
          <Message info>
            <b>Thanks for joining!</b>
            {availableMethodsString &&
              ` This workspace uses ${availableMethodsString} sign-in only.`}{' '}
            A password is required to secure your account, but to log in next time{' '}
            {availableActionsJSX}.
          </Message>
        ) : (
          <Warning errorType="noLoginMethodAvailable" />
        )}
        <Form onSubmit={onSubmit}>
          <Form.Field>
            <label>Name</label>
            <input type="text" name="name" value={name} onChange={onTextChange} required />
          </Form.Field>
          <Form.Field>
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={onTextChange}
              required
            />
          </Form.Field>

          <Button primary fluid type="submit">
            Create account
          </Button>
        </Form>
      </AuthenticationShell>
    </Page>
  )
}

InviteeRegistration.propTypes = {
  inviterName: PropTypes.string,
  company: PropTypes.string,
  name: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onTextChange: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default InviteeRegistration



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/InviteeRegistration/presentation.js